/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import React from 'react';
import { Route } from 'react-router';

import ErrorBoundaryRoutes from 'app/shared/error/error-boundary-routes';

import Series from './series';
import SeriesDetail from './series-detail';
import SeriesUpdate from './series-update';
import SeriesDeleteDialog from './series-delete-dialog';

const SeriesRoutes = () => (
  <ErrorBoundaryRoutes>
    <Route index element={<Series />} />
    <Route path="new" element={<SeriesUpdate />} />
    <Route path=":id">
      <Route index element={<SeriesDetail />} />
      <Route path="edit" element={<SeriesUpdate />} />
      <Route path="delete" element={<SeriesDeleteDialog />} />
    </Route>
  </ErrorBoundaryRoutes>
);

export default SeriesRoutes;
